/**
 * What the chat offers as buttons between the transcript and the composer. Each one is sent as the user's
 * own message, so this decides only which ones are worth offering.
 */

/**
 * Retrying is only offered where it can work. A context window that overflowed is the same size on the next
 * attempt, so a retry there is a button that visibly does nothing in the one case the user most needs an
 * explanation instead.
 */
export const isRetryableError = (errorCode: string | null): boolean =>
    errorCode !== null
    && errorCode !== ''
    && errorCode !== 'agent_input_context_too_large'
    // A stale thread was already refreshed in place, and the draft is back in the composer to be sent.
    && errorCode !== 'thread_stale';

/**
 * The answers the agent offered for the question it just asked, read from its own working memory. Anything
 * that is not a non-empty string is dropped rather than rendered as a button that sends nothing.
 */
export const suggestedAnswersOf = (state: unknown): string[] => {
    const answers = (state as Record<string, unknown> | null)?.suggestedAnswers;
    if (!Array.isArray(answers)) {
        return [];
    }

    return answers
        .filter((answer): answer is string => typeof answer === 'string')
        .map(answer => answer.trim())
        .filter(answer => answer !== '');
};
